import React from 'react';
import { useSelector } from 'react-redux';
import { List, Map } from 'immutable';
import { selectOptOutChargesThatMatchConditions } from '../../../selectors/charges';
import ChargeLineItem from './ChargeLineItem';

interface ChargeItem extends Map<string, any> {
  get(key: 'id'): number;
  get(key: 'name'): string;
  get(key: 'unit_price'): number;
  get(key: 'type'): string;
  get(key: 'quantity'): number;
  get(key: 'details'): Map<string, any>;
  get(key: 'charge_id'): string;
}

interface ChargesProps {
  chargeItems: List<ChargeItem>;
}

const Charges: React.FC<ChargesProps> = ({ chargeItems }) => {
  const availableChargesWithOptOut = useSelector(selectOptOutChargesThatMatchConditions);

  const existingChargeIds = chargeItems
    .map(item => item.getIn(['details', 'charge_id']))
    .filter(id => id != null)
    .toSet();

  const items = chargeItems.concat(
    availableChargesWithOptOut
      .filter(charge => !existingChargeIds.has(charge.get('id')))
      .map(charge =>
        Map({
          name: charge.get('name'),
          unit_price: 0,
          details: {
            charge_id: charge.get('id'),
          },
        })
      )
  );

  return (
    <>
      {items.map((item, index) => (
        <ChargeLineItem key={`charge-${item.getIn(['details', 'charge_id']) || index}`} item={item} />
      ))}
    </>
  );
};

export default Charges;
